module.exports = __webpack_public_path__ + "img/mathieu.e33ee220.png";